import Vue from 'vue';
import vueConfig from 'vue-config';
import config from '../config';

Vue.use(vueConfig, config);

export default vueConfig;
